import axios from "axios";
import configure from "redux-idle-monitor";
import moment from "moment";
// import { push } from "react-router-redux";

// Session idle timeout
//
// As configured ...
//
// User goes into INACTIVE state after 100s (1.5 min) of no activity
// While in this state, after 15 minutes the user will be logged out.
//
const idleStatusDelay = (idleStatus) => (dispatch, getState) => {
    if (idleStatus === "INACTIVE") return 100000;
    if (idleStatus === "EXPIRED") return 900000;
    // if (idleStatus === IDLESTATUS_EXPIRED) return 2700000; // Changed according to the client's request. EXPIRED time increased to 45 min
    //return 900000
};

const activeStatusAction = (dispatch, getState) => {};

const idleStatusAction = (idleStatus) => (dispatch, getState) => {
    if (idleStatus === "EXPIRED") {
        axios.get("/logout").then(() => {
            dispatch({ type: "USER_UNSET" });
            // dispatch(push("/logout"));
            window.location = "/logout";
        });
    }
};

const activeEvents = [
    "mousemove",
    "keydown",
    "wheel",
    "DOMMouseScroll",
    "mouseWheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "MSPointerDown",
    "MSPointerMove",
];

const IDLE_STATUSES = ["INACTIVE", "EXPIRED"];

const opts = {
    appName: "acumahealth-nextgen",
    IDLE_STATUSES,
    idleStatusDelay,
    activeStatusAction,
    idleStatusAction,
    activeEvents,
};

const { middleware, reducer, actions } = configure(opts);
export { middleware, reducer, actions };
